import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
const navigate = useNavigate();
const hasProcessed = useRef(false);

  useEffect(() => {
    // Empêcher la double exécution (React Strict Mode en dev)
    if (hasProcessed.current) {
      console.log("Callback already processed, skipping");
      return;
    }
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");
    
    console.log("Encoded data:", encodedData);

    if (!encodedData) {
      console.error("No data parameter in URL");
      navigate("/login?error=no_data");
      return;
    }

    try {
      // Décoder base64url-safe
      let base64 = encodedData.replace(/-/g, '+').replace(/_/g, '/');
      
      // Ajouter padding si nécessaire
      while (base64.length % 4 !== 0) {
        base64 += '=';
      }
      
      // Décoder base64 avec support UTF-8
      const binaryString = atob(base64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const jsonString = new TextDecoder().decode(bytes);
      const decodedData = JSON.parse(jsonString);
      
      console.log("Decoded data:", decodedData);

      const participant = decodedData.participant;
      const user = decodedData.user;

      if (participant && user) {
        localStorage.setItem("participant", JSON.stringify(participant));
        localStorage.setItem("user", JSON.stringify(user));
        console.log("User and participant saved to localStorage");
        navigate("/user");
      } else {
        console.error("Missing participant or user in decoded data");
        navigate("/login?error=invalid_data");
      }
    } catch (error) {
      console.error("Error decoding callback data:", error);
      navigate("/login?error=decode_failed");
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <p>Connexion en cours...</p>
    </div>
  );
}
